(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/no-competition.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/no-competition.js');

'use strict';

const NoCompetition = () => React.createElement("div", {
  className: "competition-overview-hero no-competition"
}, React.createElement("div", {
  className: "competition-overview-hero-content"
}, React.createElement("div", {
  className: "overview-hero-title"
}, React.createElement("span", null, "Det finns ingen"), React.createElement("span", null, "t\xE4vling just nu"))));
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.NoCompetition', NoCompetition);

 })(window);